import Vue from 'vue';

export default {
    /**
     * 列出当前微信用户绑定的云课堂账号及账号下的学生
     */
    getSignature() {
        const data = {
            url: window.location.href.split('#')[0],
        };
        const url = `${window.$MIDE_CONFIG.apiUrlRoot}/api/js/signature`;
        return Vue.$http.post(url, data).then(Vue.$http.$success).catch(Vue.$http.$fail);
    },
};
